import {TokenService} from "../../service/TokenService";
import {useCallback} from "react";

export const VerifyTokenViewModel = () => {

    const verifyToken = useCallback(async (token: string): Promise<string> => {
        return await TokenService.getInstance().verifyToken(token)

    }, [])

    return {
        verifyToken
    }

}